import React, { forwardRef, Ref } from "react";
import { useSearchContext } from "frontend/boards-grid/search-section/context/search-context";
import { getFilterValue } from "frontend/boards-grid/search-section/utils";
import { CloseIcon } from "frontend/icons/close";
import { SearchIcon } from "frontend/icons/search";
import styles from "./search-bar.module.css";
import classNames from "classnames";

export const SearchBar = forwardRef(
  ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (isOpen: boolean) => void }, ref: Ref<HTMLDivElement>) => {
    const { onFilterChange, filters } = useSearchContext();
    const textValue = filters.find((f) => f.type === "text")?.value as string;

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Backspace") {
        const lastFilter = filters.filter((f) => !!f.value).at(-1);
        if (lastFilter) {
          if (lastFilter.type === "text" && textValue.length > 0) {
            return;
          }
          onFilterChange(lastFilter?.type, null);
        }
      }
    };

    return (
      <div className={classNames(styles.searchbarContainer, { [styles.isEditing]: isOpen })}>
        <div
          onClick={() => setIsOpen(true)}
          className={classNames(styles.searchbar, {
            [styles.isEditing]: isOpen,
          })}
          ref={ref}
        >
          <SearchIcon size={14} style={{ flexShrink: 0 }} />
          {filters
            .filter((f) => !!f.value && f.type !== "text")
            .map((filter, i) => {
              return (
                <div className={styles.filter} key={i}>
                  {getFilterValue(filter)}
                  <CloseIcon
                    onClick={(e) => {
                      onFilterChange(filter.type, null);
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                  />
                </div>
              );
            })}
          <input
            onClick={() => setIsOpen(true)}
            type="text"
            placeholder="Search"
            value={textValue}
            onChange={(e) => {
              onFilterChange("text", e.target.value);
            }}
            onKeyDown={onKeyDown}
          />
        </div>
      </div>
    );
  }
);

SearchBar.displayName = "SearchBar";
